/**
 * Application-level feature flags.
 * Flags are fetched from AppConfig via the backend API and cached.
 *
 * Usage:
 * - In React components: use the useFeatureFlag hook
 *   const { value: isEnabled } = useFeatureFlag("enableWcCanadaClaims");
 *
 * - In async functions (e.g., loaders): use getFeatureFlag
 *   const isEnabled = await getFeatureFlag("enableIplClaims");
 *
 * - Flags are preloaded on app initialization for immediate availability
 */
export {
  getFeatureFlag,
  fetchFeatureFlags,
  getCachedFlags,
  useFeatureFlag,
  useFeatureFlags,
} from "src/api/featureFlags";

export type { FeatureFlagName } from "src/api/featureFlags";
import { getCachedFlags } from "src/api/featureFlags";

/**
 * Backward-compatible FeatureFlags object for synchronous access.
 * Uses cached flags from AppConfig. Falls back to false if not yet loaded.
 * Prefer using useFeatureFlag hook or getFeatureFlag async function instead.
 */
export const FeatureFlags = {
  get wcCanadaForm(): boolean {
    return getCachedFlags()?.enableWcCanadaClaims ?? false;
  },
};
